import { render, staticRenderFns } from "./PacientesHistoriaClinica.vue?vue&type=template&id=613b6125"
import script from "./PacientesHistoriaClinica.vue?vue&type=script&lang=js"
export * from "./PacientesHistoriaClinica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports